import { type DocumentNode, gql } from '@apollo/client';

const updatePermissionGroup: DocumentNode = gql`
  mutation update_permissions_group($id: ID!, $description: String, $mediaGroups: [MediaGroupInput]) {
    updatePermissionsGroup(permissionsGroupId: $id, description: $description, mediaGroups: $mediaGroups) {
      permissionsGroup {
        id
        name
        description
        mediaGroups {
          edges {
            node {
              id
              name
              description
            }
          }
        }
        mediapermissionSet {
          edges {
            node {
              id
              profile {
                id
                user {
                  id
                  username
                  email
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default updatePermissionGroup;
